export default {
  Videos() {
    return [
      // done born
      {
        description:
          "A Beautiful Glimpse: Baby's First Ultrasound Moments",
        memoryDate: "1952-02-07T00:00:00",
        title: "First ultrasound",
        videoUrl: require("@/assets/videos/birth.mp4"), // todo delete this video and another
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text:
              "Wow, technology is incredible! Seeing the baby move like that is so magical!",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 12,
                text:
                  "I know, right? It's like a sneak peek into their little world!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "The detail is amazing these days. You can even see them yawn sometimes!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "Agreed! It's like meeting them before they're even born.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "That heartbeat sound is so soothing. Pure magic.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text:
                  "Totally agree! It's like hearing the rhythm of life itself.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "It's always such a relief to hear it during an ultrasound appointment!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "I always tear up a little when I hear it. It's such an emotional moment.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Is it just me, or does the baby look like they're waving at the camera?",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "Haha, definitely! They're saying 'hello, world!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "Or maybe they're saying 'leave me alone, I'm cozy!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "I can't believe how much you can see on these ultrasounds now. So clear!",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text:
                  "It's amazing, isn't it? Technology has come so far!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Back in the day, it was just blobs and guesses!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text:
                  "Yeah, now you can even see tiny facial expressions sometimes!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "I think I just saw a little yawn! Babies are so adorable.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 14,
                text:
                  "Yes! They get tired from all that growing and kicking!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Look at those tiny fingers and toes. Absolute perfection!",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 9,
                text:
                  "It's amazing how fully formed they are even so early!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "I know! Those little hands will be holding yours in no time.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "The way the baby is moving, they might be a future gymnast!",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text:
                  "Haha, or a dancer! Look at those moves!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text:
              "Ultrasounds are such a bonding moment for parents. So special!",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text:
              "Did anyone else's baby seem to be camera shy during their ultrasound?",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 26,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done learning to walk
      {
        description: "John took his first steps at 1 year old, and never looked back",
        memoryDate: "1953-11-01T00:00:00",
        title: "John's first steps",
        videoUrl: require("@/assets/videos/walk.mp4"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "Look at him go! His very first steps into the world. So proud of you, little John.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 20,
                text: "He was always unstoppable, even as a baby!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "His determination started young. That never changed.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "Those first steps turned into miles of adventure. He lived life to the fullest.",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 17,
                text: "Absolutely, he didn't waste a single day.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "From these tiny steps to all the places he traveled...what a journey!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "He inspired us all to explore more. Missing him so much.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Little John learning to walk! Such a wonderful memory to hold onto.",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "It's amazing to look back and see where it all started.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "This reminds me of how determined he always was.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This little guy was so eager to take on the world, even back then.",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text: "He never shied away from a challenge. Born to explore!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "You could tell he had big things ahead of him, even at this age.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "He left a lasting mark wherever he went. Forever missed.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Seeing him take those first steps... it's like he was ready to conquer life.",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 24,
                text: "And he did just that. He was a real go-getter.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This picture shows his fearless side, ready to run before he could even walk!",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 5,
                text: "This picture captures his essence so perfectly.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "He never lost that spirit. A true adventurer at heart.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Such a sweet moment! Those wobbly steps were just the beginning.",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "He was always pushing forward, one step at a time.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Those little steps were the first of many big ones. Look at him go!",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "Seeing him take his first steps is so heartwarming. He was a force from day one.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 24,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done birthday
      {
        description: "John celebrate the pure joy of a 2-year-old's birthday as they explore their cake for the first time!",
        memoryDate: "1954-11-11T00:00:00",
        title: "Sweet Moments: A Kid's First Cake Touch on Their 2nd Birthday!",
        videoUrl: require("@/assets/videos/birthday.mp4"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "The way they're so curious about the cake is just priceless!",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 20,
                text: "I know, right? They're like, 'Can I eat this?",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "The hesitation before the first touch is the cutest!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "Look at that tiny handprint in the frosting—so adorable!",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 17,
                text: "It's the perfect little souvenir of the day!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "I hope they took a picture of it before it got completely destroyed!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "That frosting probably ended up everywhere—classic toddler move!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "The way they're tasting the frosting is too funny!",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "It's always that confused look, like 'Is this okay to eat?",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "I love how kids always start with just a finger, then go all in!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "The giggles when they realized it's delicious—so pure!",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text: "It's the best sound ever! Pure joy.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "That moment of discovery is so heartwarming.",
                imageUrl:
                  "",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Nothing beats a toddler's laugh—it's contagious!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "The cake smash is my favorite part of any toddler's birthday!",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 24,
                text: "Same here! It's like their rite of passage.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "They look so proud after touching the cake, like they accomplished something big!",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 5,
                text: "Haha, it's like Look, I did it!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "They're probably thinking they're the chef now!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This is such a classic birthday moment. It never gets old!",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "Agreed! Every kid has their own unique reaction, and it's always adorable.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "I love how everyone's cheering them on—it's such a wholesome vibe!",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "Who needs utensils when you have hands? Toddler logic at its best!",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 24,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done friends
      {
        description: "Here's to great friends and good times!",
        memoryDate: "1979-08-02T00:00:00",
        title: "Cheers to Friendship: A Toast with Beers!",
        videoUrl: require("@/assets/videos/friends.mp4"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "Cheers to moments like this! Friendship and beer—a perfect combo.",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 20,
                text: "Absolutely! It's all about celebrating the little things in life.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Nothing like clinking glasses to make the night memorable!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "The way everyone's smiling just shows how much fun they're having!",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 17,
                text: "Right? You can tell this group really knows how to enjoy life.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "It's the kind of energy that makes you want to join in!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Moments like these remind you how important friends are.",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Beer cheers always make for the best photos!",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "Totally! Everyone holding their glasses up makes it so photogenic.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Especially when the lighting hits the beer just right!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "The sound of glasses clinking is just so satisfying!",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text: "It's like a soundtrack for good times!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "And that first sip right after the cheers is always the best",
                imageUrl:
                  "",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "It's the universal sign of celebration!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Love how they all made eye contact during the toast. True friends!",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 24,
                text: "Eye contact during a toast just makes it more meaningful.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "What's the occasion? Or do we even need one to celebrate with friends?",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 5,
                text: "Honestly, just being together is reason enough!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "True! Every day with friends is a celebration.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "I love how beer brings people together like this!",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "I love how beer brings people together like this!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "You can just tell this group has so much love for each other!",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "I hope they made a good toast! That's always the fun part.",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 24,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
      // done food
      {
        description: "There's nothing like sharing a meal with your favorite people!",
        memoryDate: "1983-06-12T00:00:00",
        title: "Good Food, Great Friends: A Table Full of Joy",
        videoUrl: require("@/assets/videos/food.mp4"),
        location: "Los Angeles",
        personId: "01HBV2F63YAVY21T6SQQFSTH38",
        ownerId: "01H1F22K47ZPK57TYBHV763166",
        friends: [],
        id: "01HDRXCED6VTCV877DHTQS0EPX",
        createdAt: "2023-10-27T15:52:26.7900875Z",
        modifiedAt: "2024-08-06T11:02:05.7634982Z",
        comments: [
          {
            text: "The food looks amazing, but the laughter is even better!",
            likes: 19,
            fullName: "Jane Smith",
            imageUrl:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-04-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 20,
                text: "Exactly! Food tastes better when shared with friends.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "I wonder what the inside joke was—everyone looks so happy!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              }
            ],
          },
          {
            text: "I love how everyone is reaching for the food at the same time. Classic friends moment!",
            likes: 11,
            fullName: "Alexander Adams",
            imageUrl:
              "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 17,
                text: "Haha, it's like a race to see who gets the last bite!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Reminds me of my friends—we always fight over the fries!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "True friendship means no judgment when you take the biggest slice!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This is giving me major dinner party goals!",
            likes: 13,
            fullName: "William Nelson",
            imageUrl:
              "https://images.unsplash.com/photo-1544723795-3fb6469f5b39",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 11,
                text: "Same here! I need to plan one soon with my squad.",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Agreed! What's on the menu? It looks so good!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "The food looks so delicious! Anyone know the recipe for that pasta?",
            likes: 16,
            fullName: "Mia Wright",
            imageUrl:
              "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-03-02T16:43:20.1659641Z",
            thread: [
              {
                likes: 18,
                text: "I was wondering the same thing—it looks so creamy!",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "It might be homemade. Those are always the best meals.",
                imageUrl:
                  "",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
              {
                likes: 22,
                text: "Probably loaded with cheese—my kind of pasta!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "The way they're all laughing makes me think this is one hilarious group!",
            likes: 9,
            fullName: "Joshua Hall",
            imageUrl:
              "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-14T16:43:20.1659641Z",
            thread: [
              {
                likes: 24,
                text: "Definitely! You can feel the good vibes through the screen.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "This is giving me such warm, nostalgic vibes.",
            likes: 20,
            fullName: "Olivia Walker",
            imageUrl:
              "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-02-04T16:43:20.1659641Z",
            thread: [
              {
                likes: 5,
                text: "Me too! Reminds me of family dinners growing up.",
                fullName: "Alice Johnson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                imageUrl:
                  "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
                createdAt: "2024-04-04T16:43:31.1606916Z",
              },
              {
                likes: 11,
                text: "Or those late-night hangouts with friends where the food keeps coming!",
                imageUrl:
                  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
                fullName: "Michael Wilson",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-02-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Look at all the different dishes on the table! It's like a feast!",
            likes: 7,
            fullName: "Daniel Harris",
            imageUrl:
              "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-31T16:43:20.1659641Z",
            thread: [
              {
                likes: 22,
                text: "That's how you do it—everyone brings their favorite dish!",
                imageUrl:
                  "https://images.unsplash.com/photo-1511367461989-f85a21fda167",
                fullName: "David Moore",
                id: "01HTMZWYYRG0J4DPQB5RSJRXNA",
                userId: "01H1F22K47ZPK57TYBHV763166",
                entityId: "01HTMZWM75QZTSV1BV3929KZP9",
                thread: [],
                createdAt: "2024-01-04T16:43:31.1606916Z",
              },
            ],
          },
          {
            text: "Nothing beats sitting down with friends and catching up over a meal.",
            likes: 15,
            fullName: "Chris Martin",
            imageUrl:
              "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2024-01-24T16:43:20.1659641Z",
            thread: [],
          },
          {
            text: "Everyone looks so happy. This is what friendship goals look like!",
            likes: 12,
            fullName: "Linda Thomas",
            imageUrl:
              "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6",
            id: "01HTMZWM75QZTSV1BV3929KZP9",
            userId: "01H1F22K47ZPK57TYBHV763166",
            entityId: "01HDRXCED6VTCV877DHTQS0EPX",
            createdAt: "2023-12-14T16:43:20.1659641Z",
            thread: [],
          },
        ],
        likes: 24,
        bookmarkedByLoggedInUser: "01HW8JZM1J81FZC72Q1N566C6C",
      },
    ]
  }
};
